import { useNuxtApp } from "#app"

export default defineNuxtPlugin((nuxtApp) => {
	const runtimeConfig = useRuntimeConfig()
	const { $apiHelper } = useNuxtApp()

	const buildApiUrl = (appendPath) => {
		return runtimeConfig.public.SERVICES.MS_BASE_URL + "api/ticketco-tickets/" + appendPath
	}

	nuxtApp.provide("termsApiService", {
		$storeTerms: async (email, aws_event_id, signature, signed_at) => {
			const url = buildApiUrl("store_terms_agreement")
			const requestOptions = $apiHelper.$initNoCachingHeader()
			requestOptions.method = "POST"
			requestOptions.body = {
				email: email,
				aws_event_id: aws_event_id,
				signature: signature,
				signed_at: signed_at,
			}

			const { data, pending, error, status } = await useFetch(url, requestOptions)

			$apiHelper.$handleAPIErrors(
				pending,
				status,
				error,
				"Something went wrong while storing the signature",
				requestOptions
			)

			return { data, pending, status }
		},
	})
})
